"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _maybeChildMenu = _interopRequireDefault(require("./maybe-child-menu"));
var _styledComponents = require("./styled-components");
var _overrides = require("../helpers/overrides");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/ // Components
// Types

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function OptionProfile(props, ref) {
  const {
    item,
    getChildMenu,
    getProfileItemLabels,
    getProfileItemImg,
    getProfileItemImgText,
    overrides = {},
    resetMenu = () => {},
    $isHighlighted,
    renderAll,
    ...restProps
  } = props;
  const [ListItemProfile, listItemProfileProps] = (0, _overrides.getOverrides)(overrides.ListItemProfile, _styledComponents.StyledListItemProfile);
  const [ProfileImgContainer, profileImgContainerProps] = (0, _overrides.getOverrides)(overrides.ProfileImgContainer, _styledComponents.StyledProfileImgContainer);
  const [ProfileImg, profileImgProps] = (0, _overrides.getOverrides)(overrides.ProfileImg, _styledComponents.StyledProfileImg);
  const [ProfileLabelsContainer, profileLabelsContainerProps] = (0, _overrides.getOverrides)(overrides.ProfileLabelsContainer, _styledComponents.StyledProfileLabelsContainer);
  const [ProfileTitle, profileTitleProps] = (0, _overrides.getOverrides)(overrides.ProfileTitle, _styledComponents.StyledProfileTitle);
  const [ProfileSubtitle, profileSubtitleProps] = (0, _overrides.getOverrides)(overrides.ProfileSubtitle, _styledComponents.StyledProfileSubtitle);
  const [ProfileBody, profileBodyProps] = (0, _overrides.getOverrides)(overrides.ProfileBody, _styledComponents.StyledProfileBody);
  const ItemImg = getProfileItemImg(item);
  const {
    title,
    subtitle,
    body
  } = getProfileItemLabels(item);
  return /*#__PURE__*/React.createElement(_maybeChildMenu.default, {
    ref: ref,
    getChildMenu: getChildMenu,
    isOpen: !!$isHighlighted,
    item: item,
    resetParentMenu: resetMenu,
    renderAll: renderAll,
    overrides: overrides
  }, /*#__PURE__*/React.createElement(ListItemProfile, _extends({}, restProps, listItemProfileProps), /*#__PURE__*/React.createElement(ProfileImgContainer, profileImgContainerProps, ItemImg && (typeof ItemImg === 'string' ?
  /*#__PURE__*/
  // Render img src string wrapped with image component
  React.createElement(ProfileImg, _extends({
    src: ItemImg,
    alt: getProfileItemImgText(item)
  }, profileImgProps)) :
  /*#__PURE__*/
  // Or just render the entire component user specified
  React.createElement(ItemImg, profileImgProps))), /*#__PURE__*/React.createElement(ProfileLabelsContainer, profileLabelsContainerProps, title && /*#__PURE__*/React.createElement(ProfileTitle, profileTitleProps, title), subtitle && /*#__PURE__*/React.createElement(ProfileSubtitle, profileSubtitleProps, subtitle), body && /*#__PURE__*/React.createElement(ProfileBody, profileBodyProps, body))));
}

// @ts-ignore
const forwarded = /*#__PURE__*/React.forwardRef(OptionProfile);
forwarded.displayName = 'OptionProfile';
var _default = exports.default = forwarded;